"use client";

import Image from "next/image";
import {memo, useMemo, useState} from "react";
import {useTheme} from "@mui/material/styles";
import Box from "@mui/material/Box";
import {PictureWithBlurProps} from "@/types/general";


function PictureWithBlur({
                             src,
                             alt = "لوگو",
                             width,
                             height,
                             wrapperSx,
                             style,
                             fit = "contain",
                             priority = false,
                             ...rest
                         }: PictureWithBlurProps) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === "dark";
    const [hasError, setHasError] = useState(false);

    const isValidSrc = typeof src === "string" && src.trim() !== "";
    const finalSrc = useMemo(() => {
        return !hasError && isValidSrc ? `${process.env.NEXT_PUBLIC_ASSETS_URL}${src}` : "/logo.svg";
    }, [src, hasError, isValidSrc]);

    const isFallback = !isValidSrc || hasError;
    const shouldBlur = !isFallback && width >= 40 && height >= 40;


    return (
        <Box
            width={width}
            height={height}
            position="relative"
            overflow="hidden"
            sx = {{
                ...wrapperSx,
            }}
        >
            <Image
                src = {finalSrc}
                alt = {alt}
                fill
                sizes={`${width}px`}
                priority={priority}
                fetchPriority={priority ? "high" : "auto"}
                // placeholder={shouldBlur ? "blur" : "empty"}
                placeholder = "empty"
                blurDataURL = {shouldBlur ? finalSrc : undefined}
                onError = {() => setHasError(true)}
                {...rest}
                style = {{
                    objectFit: fit,
                    objectPosition: "center",
                    display: "block",
                    opacity: isValidSrc && !hasError ? 1 : isDarkMode ? 1 : 0.1,
                    transform: isFallback ? "scale(.8)" : "scale(1)",
                    transition: "opacity 0.2s ease, transform 0.2s ease",
                    ...style,
                }}
            />
        </Box >
    );
}

export default memo(PictureWithBlur, (prevProps, nextProps) => prevProps.src === nextProps.src);
